export const logoForLanguage = (language) =>
  language === "ar"
    ? "/images/redwan-logo-ar-B_GlW2WN.png"
    : "/images/redwan-logo-en-BFMhwaZ3.png";
